import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            🎬 吃瓜视频
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            深度解析、事件复盘、独家专访，用视频还原每一个热点真相
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer"
            >
              <div className="relative h-44 md:h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20"></div>
                {/* Play button overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                {/* Duration badge */}
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-white text-[10px] font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}